export default "__VITE_ASSET__71006eeb__"